import type { FC } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

interface HeaderProps {
  truckCount: number;
  driverCount: number;
  onDriversClick: () => void;
  onDispatchClick: () => void;
  activeTaskCount?: number;
}

const Header: FC<HeaderProps> = ({ truckCount, driverCount, onDriversClick, onDispatchClick, activeTaskCount = 0 }) => {
  const { user, logout } = useAuth();

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <span className="logo-text">Grossistify</span>
        </div>
      </div>
      
      <div className="header-center">
        <div className="status-bar">
          <div className="status-item">
            <span className="status-label">Lastbilar</span>
            <span className="status-value">{truckCount}</span>
          </div>
          <div className="status-divider" />
          <button className="status-item status-item-clickable" onClick={onDriversClick} title="Hantera förare">
            <span className="status-label">Förare</span>
            <span className="status-value text-accent">{driverCount}</span>
          </button>
          <div className="status-divider" />
          <button className="status-item status-item-clickable dispatch-btn" onClick={onDispatchClick} title="Öppna Dispatch Center">
            <span className="status-label">Uppdrag</span>
            <span className="status-value">
              {activeTaskCount > 0 && <span className="active-badge">{activeTaskCount}</span>}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                <path d="M16 7V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v3"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
      
      <div className="header-right">
        <div className="user-menu">
          <div className="user-avatar">{user?.name?.charAt(0) || 'U'}</div>
          <span className="user-name">{user?.name || 'Användare'}</span>
          <button className="logout-btn" onClick={logout} title="Logga ut">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
